export enum CookieBannerType {
  RBI_COOKIE_BANNER = 'customCookieBanner',
  ONE_TRUST_COOKIE_BANNER = 'oneTrust',
}
